/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionType } from './ConditionType';
import {
    ConditionTypeFromJSON,
    ConditionTypeFromJSONTyped,
    ConditionTypeToJSON,
    ConditionTypeToJSONTyped,
} from './ConditionType';

/**
 * 
 * @export
 * @interface AcceptanceCriteriaCondition
 */
export interface AcceptanceCriteriaCondition {
    /**
     * 
     * @type {ConditionType}
     * @memberof AcceptanceCriteriaCondition
     */
    type: ConditionType;
    /**
     * 
     * @type {number}
     * @memberof AcceptanceCriteriaCondition
     */
    minScore: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AcceptanceCriteriaCondition
     */
    match?: Array<string>;
}



/**
 * Check if a given object implements the AcceptanceCriteriaCondition interface.
 */
export function instanceOfAcceptanceCriteriaCondition(value: object): value is AcceptanceCriteriaCondition {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('minScore' in value) || value['minScore'] === undefined) return false;
    return true;
}

export function AcceptanceCriteriaConditionFromJSON(json: any): AcceptanceCriteriaCondition {
    return AcceptanceCriteriaConditionFromJSONTyped(json, false);
}

export function AcceptanceCriteriaConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptanceCriteriaCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ConditionTypeFromJSON(json['type']),
        'minScore': json['minScore'],
        'match': json['match'] == null ? undefined : json['match'],
    };
}

export function AcceptanceCriteriaConditionToJSON(json: any): AcceptanceCriteriaCondition {
    return AcceptanceCriteriaConditionToJSONTyped(json, false);
}

export function AcceptanceCriteriaConditionToJSONTyped(value?: AcceptanceCriteriaCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': ConditionTypeToJSON(value['type']),
        'minScore': value['minScore'],
        'match': value['match'],
    };
}

